import { useEffect, useState, useMemo } from "react";
import { getProducts } from "../services/productService";
import ProductCardNew from "../components/ProductCard/ProductCardNew";
import VariationModal from "../components/VariationModal";
import { useCart } from "../context/CartContext";
import Filters from "../components/Filters";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import HomeContainer from "../components/HomeContainer/HomeContainer";
import ProductsPageSkeleton from "../components/Products/ProductsPageSkeleton";
import AttributeValueFilter from "../components/Products/ProductFilters/AttributeValueFilter/AttributeValueFilter";

import "../styles/Products.css";

import {
  CollectionProvider,
  CollectionImage,
  CollectionTitle,
  CollectionDescription,
  CollectionBadge,
} from "../components/Collection";

import { useQuery, keepPreviousData } from "@tanstack/react-query";
import {
  SlidersHorizontal,
  X,
  FunnelPlus,
  Funnel,
  ArrowUpNarrowWide,
  ArrowUpDown,
  ChevronDown,
  ChevronLeft,
} from "lucide-react";

import { Link, useLocation } from "react-router-dom";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";

function Products() {
  const { addToCart } = useCart();

  const [showFullExplain, setShowFullExplain] = useState(false);
  const location = useLocation();

  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );

  const categoryFilter = searchParams.get("c");
  const groupFilter = searchParams.get("g");
  const brandFilter = searchParams.get("brand");
  const amazingFilter = searchParams.get("amazing");

const onlyAmazing =
  amazingFilter === "1" ||
  amazingFilter === "true";

console.log("AMAZING:", {
    amazingFilter,
    onlyAmazing,
});

  const groupIds = useMemo(() => {
    if (!groupFilter) return [];

    return groupFilter.split(",").map(Number).filter(Boolean);
  }, [groupFilter]);

  const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const [isSortOpen, setIsSortOpen] = useState(false);
  const [isMobileFiltersOpen, setIsMobileFiltersOpen] = useState(false);
  useEffect(() => {
    document.body.style.overflow = isFiltersOpen ? "hidden" : "auto";
  }, [isFiltersOpen]);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showVariationModal, setShowVariationModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    Number(localStorage.getItem("products-page")) || 1,
  );

  const [showAllBrands, setShowAllBrands] = useState(false);

  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("");
  const [brands, setBrands] = useState([]);

  const [sort, setSort] = useState(
    localStorage.getItem("products-sort") || "all",
  );

  const [onlyAvailable, setOnlyAvailable] = useState(false);
  const [onlyDiscounted, setOnlyDiscounted] = useState(false);
  const [onlyGiftProducts, setOnlyGiftProducts] = useState(false);


  const [minPrice, setMinPrice] = useState(null);
  const [maxPrice, setMaxPrice] = useState(null);
  const [priceFilterApplied, setPriceFilterApplied] = useState(false);








  const activeFiltersCount = [
    brands.length > 0,
    category && category !== "all",
    onlyAvailable === true,
    onlyDiscounted === true,
    onlyGiftProducts === true,
    priceFilterApplied === true,
  ].filter(Boolean).length;

  useEffect(() => {
    if (isSortOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [isSortOpen]);

  useEffect(() => {
    if (isFiltersOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [isFiltersOpen]);

  useEffect(() => {
    document.body.style.overflow = isFiltersOpen ? "hidden" : "auto";
  }, [isFiltersOpen]);

  const attributeValues = useMemo(() => {
    const value = searchParams.get("attributeValues");

    if (!value) {
      return [];
    }

    return value
      .split(",")
      .map(Number)
      .filter(Boolean);
  }, [searchParams]);

  // Stable query key
  const queryKey = useMemo(
    () => [
      "products",
      {
        page: currentPage,
        attributeValues,
        sort,
        search,
        category,
        brandFilter,
        brands,
        categoryFilter,
        groupIds,
        onlyAmazing,
        minPrice: priceFilterApplied ? minPrice : null,
        maxPrice: priceFilterApplied ? maxPrice : null,
        onlyAvailable,
        onlyDiscounted,
        onlyGiftProducts,
      },
    ],
    [
      currentPage,
      attributeValues,
      sort,
      search,
      category,
      brandFilter,
      brands,
      categoryFilter,
      groupIds,
      onlyAmazing,
      minPrice,
      maxPrice,
      priceFilterApplied,
      onlyAvailable,
      onlyDiscounted,
      onlyGiftProducts,
    ],
  );

  const { data, isLoading, isFetching } = useQuery({
    queryKey,

    queryFn: () =>
      getProducts({
        page: currentPage,
        sort,
        search,
        category,
        brand: brandFilter,
        brands,
        attributeValues,
        onlyAmazing,
        menuCategory: categoryFilter,
        menuGroups: groupIds,

        ...(priceFilterApplied && { minPrice }),
        ...(priceFilterApplied && { maxPrice }),

        onlyAvailable,
        onlyDiscounted,
        onlyGiftProducts,
      }),

    placeholderData: keepPreviousData,

    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
  const collection = data?.collection ?? null;
  const breadcrumb = data?.breadcrumb ?? null;

  console.log(breadcrumb);

  const products = data?.data ?? [];
  const totalProducts = data?.meta?.total ?? 0;
  const lastPage = data?.meta?.last_page ?? 1;


  const maxProductPrice = Number(
    data?.filters?.maxPrice ??
    data?.maxPrice ??
    0
  );

  const [priceRange, setPriceRange] = useState([0, 0]);

  useEffect(() => {

    if (maxProductPrice <= 0) {
      return;
    }

    setPriceRange((prev) => {

      if (
        prev[0] === 0 &&
        prev[1] === 0
      ) {
        return [
          0,
          maxProductPrice
        ];
      }

      return [
        Math.min(
          Number(prev[0]),
          maxProductPrice
        ),

        Math.min(
          Number(prev[1]),
          maxProductPrice
        ),
      ];
    });

  }, [maxProductPrice]);

  console.log("MAX PRICE:", maxProductPrice);

  console.log({
    maxProductPrice,
    priceRange,

    maxPrice: data?.maxPrice,
  });

  const availableBrands = data?.filters?.brands ?? [];

  const availableAttributes = data?.attributes ?? [];

  console.log("FULL PRODUCT RESPONSE:", availableAttributes);

  const breadcrumbItems = useMemo(() => {
    return [
      {
        type: "products",
        id: "products",
        name: "محصولات",
        url: "/products",
      },

      ...(data?.breadcrumb || []),
    ];
  }, [data?.breadcrumb]);

  console.log("breadcrumb Itemsss", breadcrumbItems);




  // Reset page when non-price filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [
    search,
    category,
    sort,
    brandFilter,
    attributeValues,
    categoryFilter,
    groupFilter,
    onlyAvailable,
    onlyDiscounted,
    onlyGiftProducts,
  ]);
  // Persist sort & page
  useEffect(() => {
    localStorage.setItem("products-sort", sort);
  }, [sort]);

  useEffect(() => {
    localStorage.setItem("products-page", currentPage);
  }, [currentPage]);

  const toggleBrand = (brandId) => {
    setBrands((prev) =>
      prev.includes(brandId)
        ? prev.filter((b) => b !== brandId)
        : [...prev, brandId],
    );
  };

  const pages = Array.from({ length: lastPage }, (_, i) => i + 1);

  // if (isLoading) {
  //   return (
  //     <HomeContainer>
  //       <div className="grid">
  //         {[...Array(10)].map((_, i) => (

  //           <div key={i} className="skeleton skeleton-card"></div>

  //         ))}
  //       </div>
  //     </HomeContainer>
  //   );
  // }

  if (isLoading) {
    return <ProductsPageSkeleton productCount={12} />;
  }

  return (
    <CollectionProvider collection={collection}>
      <Breadcrumbs items={breadcrumbItems} />

      <div className="home-layout">
        {/* PRODUCTS GRID */}
        <div className="container">
          <div className="products-page">
            {isFiltersOpen && (
              <div
                className="filters-overlay"
                onClick={() => setIsFiltersOpen(false)}
              />
            )}

            <aside className={`filters-sidebar ${isFiltersOpen ? "open" : ""}`}>
              <div className="filter-header">
                <label>
                  <FunnelPlus color="#958e8e" size={20} /> فیلترها
                </label>

                <button
                  className="close-filters"
                  onClick={() => setIsFiltersOpen(false)}
                >
                  <X />
                </button>
              </div>

              <Filters
                search={search}
                setSearch={setSearch}
                category={category}
                setCategory={setCategory}
                setBrand={setBrands}
                brands={brands}
                toggleBrand={toggleBrand}
                onlyAvailable={onlyAvailable}
                setOnlyAvailable={setOnlyAvailable}
                onlyDiscounted={onlyDiscounted}
                setOnlyDiscounted={setOnlyDiscounted}
                onlyGiftProducts={onlyGiftProducts}
                setOnlyGiftProducts={setOnlyGiftProducts}
              />

              {/* BRANDS FILTER (checkboxes) */}
              {!brandFilter && (
                <div className="brands-filter">
                  <div className="brands-header">برندها</div>

                  <div className="brands-list">
                    {(showAllBrands
                      ? availableBrands
                      : availableBrands.slice(0, 5)
                    ).map((brand) => (
                      <label key={brand.id} className="brand-item">
                        <input
                          type="checkbox"
                          checked={brands.includes(brand.id)}
                          onChange={() => toggleBrand(brand.id)}
                        />
                        {brand.name}
                        {/* ({brand.productsCount}) */}
                      </label>
                    ))}
                  </div>



                  {availableBrands.length > 5 && (
                    <button
                      className="brand-toggle-btn"
                      onClick={() => setShowAllBrands((prev) => !prev)}
                    >
                      {showAllBrands ? "نمایش کمتر" : "نمایش بیشتر"}
                    </button>
                  )}
                </div>
              )}




              <AttributeValueFilter attributes={availableAttributes} />







              {/* PRICE FILTER */}
              <div className="price-filter">

                <h4>قیمت</h4>

                <p className="price-title">
                  محدوده قیمت مورد نظر خود را انتخاب کنید
                </p>


                <Slider
                  range
                  pearling
                  min={0}
                  max={maxProductPrice}
                  value={priceRange}
                  onChange={(value) => {
                    setPriceRange(value);
                  }}
                />


                <div className="slider-number">

                  <span>
                    از{" "}
                    {Number(
                      priceRange?.[0] ?? 0
                    ).toLocaleString()}
                  </span>


                  <span>
                    تا{" "}
                    {Number(
                      priceRange?.[1] ?? 0
                    ).toLocaleString()}
                    {" "}تومان
                  </span>

                </div>


                <button
                  className="applyPrice"

                  onClick={() => {

                    const min =
                      Number(
                        priceRange?.[0] ?? 0
                      );

                    const max =
                      Number(
                        priceRange?.[1] ??
                        maxProductPrice ??
                        0
                      );

                    setMinPrice(min);

                    setMaxPrice(max);

                    setPriceFilterApplied(true);

                    setCurrentPage(1);
                  }}
                >
                  اعمال قیمت
                </button>

              </div>


            </aside>

            <main className="products-content">
              {/* HEADER */}
              <div className="products-header">
                {/* <CollectionTitle /> */}

                {onlyAmazing ? (
                  <h1 className="products-title">
                    پیشنهادهای شگفت‌انگیز
                  </h1>
                ) : (
                  <CollectionTitle />
                )}

                <div className="totalProducts">
                  <p className="totalTitle"> تعداد محصولات: </p>
                  <p className="total">{totalProducts.toLocaleString()}</p>
                </div>
              </div>

              <CollectionImage className="products-category-header" />

              <hr />

              <div className="filters-mobile">
                <div
                  className="sort-mobile"
                  onClick={() => setIsSortOpen(true)}
                >
                  <ArrowUpNarrowWide color="#958e8e" />
                  <p>مرتب سازی</p>
                </div>

                <div
                  className="filter-mobile"
                  onClick={() => setIsFiltersOpen(true)}
                >
                  {activeFiltersCount > 0 && (
                    <span className="filters-count">{activeFiltersCount}</span>
                  )}
                  <Funnel color="#958e8e" />
                  <p>فیلترها</p>
                </div>
              </div>

              {/* SORT BAR (ALL BUTTONS) */}
              <div className={`sort-bar ${isSortOpen ? "open" : ""}`}>
                <div className="filter-header">
                  <label>
                    <ArrowUpDown color="#958e8e" size={20} />
                    مرتب سازی براساس
                  </label>

                  <span
                    className="close-filters"
                    onClick={() => setIsSortOpen(false)}
                  >
                    <X />
                  </span>
                </div>

                <button
                  onClick={() => setSort("all")}
                  className={sort === "all" ? "active" : ""}
                >
                  پیش فرض
                </button>

                <button
                  onClick={() => setSort("cheap")}
                  className={sort === "cheap" ? "active" : ""}
                >
                  ارزان ترین
                </button>

                <button
                  onClick={() => setSort("expensive")}
                  className={sort === "expensive" ? "active" : ""}
                >
                  گرانترین
                </button>

                <button
                  onClick={() => setSort("name")}
                  className={sort === "name" ? "active" : ""}
                >
                  نام محصول
                </button>

                <button
                  onClick={() => setSort("newest")}
                  className={sort === "newest" ? "active" : ""}
                >
                  جدیدترین
                </button>

                <button
                  onClick={() => setSort("discount")}
                  className={sort === "discount" ? "active" : ""}
                >
                  بیشترین تخفیف
                </button>

                <button
                  onClick={() => setSort("visited")}
                  className={sort === "visited" ? "active" : ""}
                >
                  پربازدیدترین
                </button>

                <button
                  onClick={() => setSort("popular")}
                  className={sort === "popular" ? "active" : ""}
                >
                  پرفروش ترین
                </button>

                <button
                  onClick={() => setSort("brand")}
                  className={sort === "brand" ? "active" : ""}
                >
                  نام برند
                </button>

                <button
                  onClick={() => setSort("rating")}
                  className={sort === "rating" ? "active" : ""}
                >
                  محبوب ترین
                </button>
              </div>

              <hr />

              <div className="grid">
                {products.map((p) => (
                  <ProductCardNew
                    key={p.id}
                    product={p}
                    setSelectedProduct={setSelectedProduct}
                    setShowVariationModal={setShowVariationModal}
                  />
                ))}
              </div>

              {/* PAGINATION */}
              <div
                className="pagination"
                style={{ display: "flex", gap: 8, marginTop: 20 }}
              >
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                >
                  قبلی
                </button>

                {/* FIRST PAGE */}
                {currentPage > 3 && (
                  <button onClick={() => setCurrentPage(1)}>1</button>
                )}

                {/* LEFT ELLIPSIS */}
                {currentPage > 4 && <span>...</span>}

                {/* MIDDLE PAGES */}
                {Array.from({ length: lastPage }, (_, i) => i + 1)
                  .filter(
                    (page) =>
                      page >= currentPage - 2 && page <= currentPage + 2,
                  )
                  .map((page) => (
                    <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      className={currentPage === page ? "active" : ""}
                    >
                      {page}
                    </button>
                  ))}

                {/* RIGHT ELLIPSIS */}
                {currentPage < lastPage - 3 && <span>...</span>}

                {/* LAST PAGE */}
                {currentPage < lastPage - 2 && (
                  <button onClick={() => setCurrentPage(lastPage)}>
                    {lastPage}
                  </button>
                )}

                <button
                  disabled={currentPage === lastPage}
                  onClick={() => setCurrentPage((p) => p + 1)}
                >
                  بعدی
                </button>
              </div>

              <CollectionDescription />
            </main>
          </div>
        </div>

        {/* {isFetching && <div className="updating">Updating...</div>} */}
        {isFetching && (
          <div className="update-toast">
            <span>در حال دریافت اطلاعات</span>
            <div className="spinner"></div>
          </div>
        )}

        {/* VARIATION MODAL */}
        {showVariationModal && selectedProduct && (
          <VariationModal
            productId={selectedProduct.id}
            onClose={() => setShowVariationModal(false)}
            onAdd={(cartItem) => {
              addToCart(cartItem);
              setShowVariationModal(false);
            }}
          />
        )}
      </div>
    </CollectionProvider>
  );
}

export default Products;
